import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { LoadingModalModule } from '../../shared/loading-modal/loading-modal.module';
import { ModalModule } from '../../../shared/modal/modal.module';
import { WhereInPipeModule } from '../../../../pipes/collection/where-in.module';
import { WhereNotInPipeModule } from '../../../../pipes/collection/where-not-in.module';
import { BulkTaggerComponent } from './bulk-tagger.component';
import { TagsService } from '../../../../services/tags/tags.service';
import { WhereInPipe } from '../../../../pipes/collection/where-in.pipe';
import { WhereNotInPipe } from '../../../../pipes/collection/where-not-in.pipe';
import { TagInputModule } from 'ngx-chips';

@NgModule({
    imports: [
        CommonModule,
        // Shared
        SharedModule,
        // Dependencies
        LoadingModalModule,
        ModalModule,
        WhereInPipeModule,
        WhereNotInPipeModule,
        TagInputModule,
    ],
    declarations: [BulkTaggerComponent],
    exports: [BulkTaggerComponent],
    providers: [
        TagsService,
        // Pipes
        WhereInPipe,
        WhereNotInPipe,
    ],
})
export class BulkTaggerCoreModule
{
}
